import baseTheme from "@skv/frontend/src/styles/jsvariables.scss";
import nzVariables from "@skv/frontend/src/styles/nz-variables.scss";

import { timingFunctions } from "polished";
import { DefaultTheme } from "styled-components";

export const nzTheme: DefaultTheme = Object.assign({}, baseTheme, nzVariables, {
  timingFnEaseOut: timingFunctions("easeOutCubic"),
});
